import { render } from "./SelectMap.vue?vue&type=template&id=6155ab74"
import script from "./SelectMap.vue?vue&type=script&lang=js"
export * from "./SelectMap.vue?vue&type=script&lang=js"
script.render = render

export default script